<!-- eslint-disable max-len -->
<template>
  <div
    class="
      w-full
      h-full
      z-50
      fixed
      left-0
      top-0
      flex
      items-center
      sidebar-blocks
    "
  >
    <div
      class="w-full h-full bg-gray-900 opacity-50 absolute top-0 left-0"
      @click="close"
    ></div>
    <div
      class="
        relative
        top-0
        left-0
        rounded
        shadow-lg
        z-50
        overflow-y-auto
        top-0
        left-0
        h-full
        side-bar
        w-10/12
      "
    >
      <div
        class="
          w-full
          h-37
          flex
          items-end
          justify-start
          pt-2
          pl-4
          pr-4
          pb-6
          mb-1
          top-information
        "
      >
        <div class="w-full flex items-center justify-start" @click="
            () => {
              if ($route.name !== 'ProfileLanding') {
                $router.push({ name: 'ProfileLanding' });
              }
            }
          ">
          <div class="blcok mr-6 w-16 h-16 rounded-full">
            <img
              class="block rounded-full ring-2 ring-white w-full h-full"
              style="height: 64px; width: 64px; left: 16px; top: 64px"
              v-if="user.pic_url_thumb"
                :src="user.pic_url_thumb"
              alt=""
            />
            <img
              class="block rounded-full ring-2 ring-white w-full h-full"
              style="height: 64px; width: 64px; left: 16px; top: 64px"
              v-if="!user.pic_url_thumb"
                src="./../../assets/images/portrait_placeholder.png"
              alt=""
            />
          </div>
          <div class="block realtive">
            <h2 class="block font-bold text-white text-xl m-0">
              {{ user.first_name }} {{ user.last_name }}
            </h2>
            <p class="text-white font-normal text-sm m-0">
              {{ user.location }}
            </p>
          </div>
        </div>
      </div>
      <ul class="block relative text-left pl-4 pr-4">
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img src="../../assets/images/User.png" alt="" class="w-6 h-6" />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            link="offerSearch"
            :title="$t('pages.sidebar.home_page')"
          ></MenuItem>
        </li>
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img
            src="../../assets/images/list_view 1.png"
            alt=""
            class="w-6 h-6"
          />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            link="Applications"
            :title="$t('pages.sidebar.applications')"
          ></MenuItem>
        </li>
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img
            src="../../assets/images/heart_outline 1.png"
            alt=""
            class="w-6 h-6"
          />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            link="favoriteOffers"
            :title="$t('pages.sidebar.favorites')"
          ></MenuItem>
        </li>
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img
            src="../../assets/images/macos_minimize 1.png"
            alt=""
            class="w-6 h-6"
          />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            :action="comingSoon"
            :action-text="$t('pages.common.buttons.dis86')"
            :title="$t('pages.sidebar.my_exclusions')"
          ></MenuItem>
        </li>
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img src="../../assets/images/help 1.png" alt="" class="w-6 h-6" />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            link="ProfileFAQ"
            :title="$t('pages.sidebar.information')"
          ></MenuItem>
        </li>
        <li
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
          "
        >
          <img
            src="../../assets/images/icons8-coronavirus 1.png"
            alt=""
            class="w-6 h-6"
          />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            :action="comingSoon"
            :action-text="$t('pages.common.buttons.dis87')"
            :title="$t('pages.sidebar.covid')"
          ></MenuItem>
        </li>
        <li
          v-if="loggedIn"
          class="
            w-full
            text-center
            cursor-pointer
            flex
            items-center
            justify-start
            pt-4
            pb-4
            pl-2
            pr-2
            mt-10
          "
        >
          <img
            src="../../assets/images/icons8-logout_rounded_left 1.png"
            alt=""
            class="w-6 h-6"
          />
          <MenuItem
            class="text-lgg font-bold pl-6 text-white"
            :title="$t('pages.sidebar.buttons.logout')"
            @select="logout"
          ></MenuItem>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MenuItem from "@/components/MenuItem";

export default {
  name: "AuthMenu",
  components: { MenuItem },
  methods: {
    close() {
      this.$store.commit("app/hideMainMenu");
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => this.$router.push({ name: "confirmCell" }))
        .catch(() => {});
    },
    comingSoon(heading) {
      this.$store.commit("app/showNotification", {
        heading: heading,
        buttons: {
          okay: {
            text: "Ok",
            action: () => {},
          },
        },
      });
      this.$store.commit("app/hideMainMenu");
    },
  },
};
</script>

<style scoped>
.sidebar-blocks {
  z-index: 99999999;
}
</style>
